module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-swipeable-views/~/babel-runtime/core-js/object/define-property.js
// module id = 3490
// module chunks = 0